import type { Menu, MenuItem, MenuItemResource, Metafield, Shop } from "@shopify/hydrogen-react/storefront-api-types";
import { query } from "gql-query-builder";

import { menuFields, shopFields } from "./fields";
import { collectionFragment } from "./fragments";

/**
 * 스토어 네비게이션 리스트 조회
 */
export interface IMenuQuery {
  menu: Menu & {
    items: IMenuItem[];
  };
}

export interface IMenuItem extends MenuItem {
  resource?: MenuItemResource & {
    tag?: Metafield;
  };
}

export const menuQuery = query(
  {
    operation: "menu",
    fields: [
      "handle",
      {
        items: [
          ...menuFields,
          "tags",
          "resourceId",
          { resource: [collectionFragment] },
          { items: [...menuFields, { resource: [collectionFragment] }, { items: [...menuFields] }] },
        ],
      },
    ],
    variables: { handle: { type: "String!" } },
  },
  undefined,
  { operationName: "Menu" },
);

export interface IShopQuery {
  shop: Shop;
}

export const shopQuery = query(
  {
    operation: "shop",
    fields: [
      { termsOfService: shopFields },
      { privacyPolicy: shopFields },
      { shippingPolicy: shopFields },
      { refundPolicy: shopFields },
    ],
  },
  undefined,
  { operationName: "Shop" },
);
